// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo__23zXT","drop":"drop__2jvWJ","preview":"preview__1Vunq","interactive":"interactive__-W-qm","error":"error__1h9pR"};